export default __webpack_public_path__ + "static/media/goldman-logo.55cec704.png";